import { useEffect, useMemo, useState } from "react";
import {
  Button,
  InlineError,
  Layout,
  LegacyCard,
  Select,
} from "@shopify/polaris";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import SuccessBanner from "../../../components/banner/SuccessBanner";
import CriticalBanner from "../../../components/banner/criticalBanner";
import "./style.css";

const RANGE_OPTIONS = [
  { label: "Last 30 days", value: "30" },
  { label: "Last 90 days", value: "90" },
  { label: "Last 1 year", value: "365" },
  { label: "Last 3 years", value: "1095" },
];

const PaypalTxExport = () => {
  const { id: shopId } = useParams();
  const [merchantAccountId, setMerchantAccountId] = useState("");
  const [days, setDays] = useState("30");
  const [errors, setErrors] = useState({ merchantId: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const paypalSettingData = useSelector((s) => s.requriedPaypalSettingData);

  const merchantOptions = useMemo(() => {
    const list = paypalSettingData?.data?.content;
    if (!Array.isArray(list)) return [];
    return list
      .filter(Boolean)
      .map((s) => ({ label: s.merchantAccountId, value: s.merchantAccountId }));
  }, [paypalSettingData]);

  // Default to first merchant if none selected
  useEffect(() => {
    if (!merchantAccountId && merchantOptions.length > 0) {
      setMerchantAccountId(merchantOptions[0].value);
    }
  }, [merchantOptions, merchantAccountId]);

  const handleDownload = async () => {
    if (!merchantAccountId) {
      setErrors({ merchantId: "Select a merchant account id" });
      return;
    }
    setErrors({ merchantId: "" });
    setError("");
    setDone(false);
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.paypalTxExport(
        shopId,
        merchantAccountId,
        days,
      )}`;
      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
          Origin: `${process.env.REACT_APP_URL}`,
        },
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`);
      }
      const blob = await res.blob();
      const cd = res.headers.get("Content-Disposition") || "";
      const match = /filename="?([^"]+)"?/.exec(cd);
      const filename = match ? match[1] : `paypal_${merchantAccountId}_${days}d.csv`;

      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(objectUrl);
      setDone(true);
    } catch (e) {
      setError(e.message || "Download failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout.Section>
      <div className="wrapper">
        <LegacyCard sectioned>
          <div style={{ padding: "15px" }}>
            <LegacyCard sectioned>
              <div
                className="d-flex flex-wrap"
                style={{
                  alignItems: "end",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <div className="textFieldContainer">
                  <Select
                    label="Merchant account ID"
                    options={merchantOptions}
                    onChange={setMerchantAccountId}
                    value={merchantAccountId}
                    placeholder="Select Merchant account id"
                  />
                  {errors.merchantId && (
                    <div style={{ position: "absolute" }}>
                      <InlineError
                        message={errors.merchantId}
                        fieldID="merchantIdField"
                      />
                    </div>
                  )}
                </div>

                <div className="textFieldContainer">
                  <Select
                    label="Range"
                    options={RANGE_OPTIONS}
                    onChange={setDays}
                    value={days}
                  />
                </div>

                <div>
                  <Button primary loading={loading} onClick={handleDownload}>
                    Download CSV
                  </Button>
                </div>
              </div>

              {done && <SuccessBanner runTime={1} message="CSV downloaded" />}
              {error && <CriticalBanner runTime={1} message={error} />}
            </LegacyCard>
          </div>
        </LegacyCard>
      </div>
    </Layout.Section>
  );
};

export default PaypalTxExport;
